@use '../../scss/utility/functions' as utility;
@use './tabs-vars';

:host {
  @include tabs-vars.wb-tabs-vars;
  display: block;
  position: relative;
}

.inner {
  border-block-end: var(--tabs-border-underline);
}

.wrapper {
  display: flex;
  flex-direction: row;
  position: relative;
  gap: var(--tabs-gap);
}

.highlight {
  position: absolute;
  inset-block-end: 0;
  inset-inline-start: 0;
  height: var(--tabs-marker-weight);
  background: var(--tabs-marker-color);
  transition: all 0.3s var(--wb-move);
  margin-inline-start: calc(-1 * var(--wb-tabs-unselected-border-weight)); // Take (transparent) border into account

  @media (prefers-reduced-motion) {
    transition: transform 0s;
  }
}

:host([is-rtl]) .highlight {
  inset-inline-start: unset;
  inset-inline-end: 0;
}

:host([fitted]) .wrapper {
  padding-inline-start: 0;
  flex: 1;
}

:host([fitted]) ::slotted(.wb-tab) {
  flex: 1;
}
